/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a whole number from -999,999,999,999 to 999,999,999,999.`)
};

const es_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un número entero de -999,999,999,999 a 999,999,999,999.`)
};

const de_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine ganze Zahl von -999,999,999,999 bis 999,999,999,999 ein.`)
};

const nl_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een heel getal in van -999.999.999.999 tot 999.999.999.999.`)
};

const fr_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nombre entier entre -999 999 999 999 et 999 999 999 999.`)
};

const it_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un numero intero da -999,999,999,999 a 999,999,999,999.`)
};

const pt_br2_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um número inteiro de -999.999.999.999 a 999.999.999.999.`)
};

const pt_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um número inteiro de -999.999.999.999 a 999.999.999.999.`)
};

const ja_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−999,999,999,999から999,999,999,999までの整数を入力してください。`)
};

const zh_nw_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入一个介于 -999,999,999,999 到 999,999,999,999 之间的整数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_invalid", locale)
	if (locale === "en") return en_nw_invalid(inputs)
	if (locale === "es") return es_nw_invalid(inputs)
	if (locale === "de") return de_nw_invalid(inputs)
	if (locale === "nl") return nl_nw_invalid(inputs)
	if (locale === "fr") return fr_nw_invalid(inputs)
	if (locale === "it") return it_nw_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_nw_invalid(inputs)
	if (locale === "pt") return pt_nw_invalid(inputs)
	if (locale === "ja") return ja_nw_invalid(inputs)
	return zh_nw_invalid(inputs)
};